import React from "react"

interface BottomSheetModalProviderProps {
  children: React.ReactNode
}

// Web version of BottomSheetModalProvider - just passes through children
// since we use regular Modal instead of animated bottom sheets on web
export const BottomSheetModalProvider: React.FC<BottomSheetModalProviderProps> = ({ children }) => {
  return <>{children}</>
}
